import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { useStoreActions, useStoreState } from '../../../../store/hooks'
import ColorToMove from '../../components/ColorToMove'
import ArrowIcon from '../../icons/Arrow'
import PuzzlePracticeCharacter from '../components/PuzzlePracticeCharacter'
import PuzzlePracticeControls from '../components/PuzzlePracticeControls'
import PuzzlePracticeNotations from '../components/PuzzlePracticeNotations'
import PuzzlePracticeTitle from '../components/PuzzlePracticeTitle'
import StreaksAndRating from '../components/StreaksAndRating'

const DesktopPP: React.FC = () => {
    const myColor = useStoreState((state) => state.puzzlePracticeView.myColor)
    const disableNextButton = useStoreState((state) => state.puzzlePracticeView.disableNextButton)
    const puzzleState = useStoreState((state) => state.puzzlePracticeView.puzzleState)

    const handleNext = useStoreActions((state) => state.puzzlePracticeView.handleNext)

    const onNext = () => {
        handleNext()
    }

    return (
        <Stack alignItems="center" spacing="12px" sx={{ flexGrow: 1 }}>
            {/* Title */}
            <PuzzlePracticeTitle />
            {/* Streaks and Rating */}
            <StreaksAndRating />
            <Stack
                sx={{
                    flexGrow: 1,
                    minHeight: 0,
                    alignSelf: 'stretch',
                    borderRadius: '8px !important',
                }}
            >
                {/* Character */}
                <PuzzlePracticeCharacter />
                {/* Notations */}
                <PuzzlePracticeNotations />
            </Stack>
            {/* Color to Move */}
            <ColorToMove playerColor={myColor} />
            {/* Controls */}
            <PuzzlePracticeControls />
            {/* Next Button */}
            {puzzleState === true ? (
                <Button
                    onClick={onNext}
                    endIcon={<ArrowIcon />}
                    variant="contained"
                    size="large"
                    disabled={disableNextButton}
                >
                    Next Puzzle
                </Button>
            ) : (
                <Box sx={{ height: '48px' }} />
            )}
        </Stack>
    )
}

export default DesktopPP
